export const base64ToUint8Array = (base64) => {
  if (!base64) {
    return new Uint8Array();
  }

  const binary = atob(base64);
  const size = binary.length;
  const bytes = new Uint8Array(size);

  for (let i = 0; i < size; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes;
};
